
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Play } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ReleaseCardImageProps {
  coverArt: string;
  title: string;
  status?: 'released' | 'scheduled' | 'draft';
  onPlay: () => void;
}

const ReleaseCardImage: React.FC<ReleaseCardImageProps> = ({
  coverArt,
  title,
  status = 'released',
  onPlay
}) => {
  const statusColors = {
    released: "bg-emerald-500",
    scheduled: "bg-amber-500",
    draft: "bg-slate-500",
  };

  return (
    <div className="relative w-full aspect-square overflow-hidden">
      <img
        src={coverArt || "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=200&auto=format&fit=crop"}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
        <Button 
          size="icon" 
          variant="secondary" 
          className="rounded-full h-12 w-12 shadow-md"
          onClick={onPlay}
        >
          <Play className="h-5 w-5 ml-1" />
        </Button>
      </div>
      
      <div className="absolute top-2 right-2">
        <Badge 
          className={cn(
            "text-xs font-medium text-white",
            statusColors[status]
          )}
        >
          {status}
        </Badge>
      </div>
    </div>
  );
};

export default ReleaseCardImage;
